import {
  WebdevelopmentMain_Development_CoverImage,
  BusinessWebsiteCover,
} from "../../../assets/data/Imagedata";

import {
  DefaultIcon,
} from "../../../assets/data/icon_data";


export const BusinessWebsitePage = {
  SeoName: {
    seotitle: "businesswebsiteseo",
  },
  section2: {
    tagline: "Looking to establish your business online?",
    heading: "Transform Your Business into a Digital Powerhouse.",
    description:
      "At Cyber Space Digital, we create powerful, secure, and scalable websites tailored to your goals. Whether you're a startup, freelancer, or enterprise, we deliver digital experiences that convert visitors into customers.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Startup & Entrepreneur Websites",
      description: "Launch-ready landing pages and startup websites.",
      details: [
        "Landing Page: Ideal for promoting a single product, collecting leads, or testing new ideas. Includes a hero section, benefits, testimonials, and a strong call-to-action.",
        "Startup Website: Multi-section site to showcase your team, product, and company vision. Includes About, Services, Contact, Blog, and Newsletter sections.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Service-Based Business Websites",
      description: "Websites for professionals and local businesses.",
      details: [
        "Professional Services: For consultants, freelancers, and agencies. Includes service listings, case studies, testimonials, and contact forms.",
        "Local Businesses: Perfect for salons, clinics, or stores. Includes Google Maps, reviews, booking systems, and contact details.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Product-Based Business Websites",
      description: "Showcase and sell products effectively.",
      details: [
        "E-Commerce Website: Full-featured online store with product catalog, cart, payment gateway, and inventory management.",
        "Product Showcase: Highlight a single product or line with demos, specs, pricing tables, and customer testimonials.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Corporate & Portfolio Websites",
      description: "Present your company or creative work professionally.",
      details: [
        "Corporate Website: Ideal for enterprises. Includes company overview, leadership, services, investor info, and media updates.",
        "Portfolio Website: For creatives and agencies. Display your work, client testimonials, and contact options.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand & Community Websites",
      description: "Engage your audience with content-driven platforms.",
      details: [
        "Personal Brand: Ideal for influencers, coaches, and experts. Includes a blog, media features, podcast section, and online course integration.",
        "Content Blog: Share news, guides, or niche content. Includes categories, search, SEO structure, and newsletter sign-up.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "SaaS / App Websites",
      description: "Promote and convert users for your app or software.",
      details: [
        "SaaS Landing: Perfect for showcasing features, integrations, pricing, and user benefits. Includes signup/login sections and demos.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Hybrid & Multi-Purpose Websites",
      description: "Flexible websites that do it all.",
      details: [
        "Combine multiple goals like blogging, booking, e-commerce, and portfolios. Ideal for scaling businesses that serve diverse audiences.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter",
      price: "",
      features: [
        "1 Page Website",
        "Basic Responsive Design",
        "1 Business Email ID",
        "Delivery in 3 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business",
      price: "",
      features: [
        "Up to 5 Pages",
        "Custom UI Design",
        "Domain & Hosting Included",
        "5 Business Email IDs",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium",
      price: "",
      features: [
        "Up to 10 Pages",
        "Advanced UI/UX + Animations",
        "SEO Optimized",
        "Free Maintenance for 3 Months",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BusinessWebsiteCover,
  title: "Looking for a Business Website?",
  subtitle:
    "Cyber Space Digital is your trusted partner for modern, effective, and high-performance web development tailored to your unique business needs.",
  coverImage: {
    src: WebdevelopmentMain_Development_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What type of website should I choose for my business?",
      answer:
        "It depends on your business goals. If you're starting out, a Startup or Landing Page is ideal. For services, choose a Service-Based Website. E-commerce stores need a Product-Based Website, while established companies may go for Corporate or Hybrid Websites.",
    },
    {
      question: "What is included in the  Starter plan?",
      answer:
        "The Starter plan includes: 1-page responsive website, basic design, 1 professional email ID, and a 3-day delivery turnaround.",
    },
    {
      question: "Do your plans include domain and hosting?",
      answer:
        "Yes, domain and hosting are included starting from the Business plan () and above. The Starter plan can be upgraded to include these for an additional fee.",
    },
    {
      question: "Can I upgrade my plan later?",
      answer:
        "Absolutely. You can start with a basic plan and upgrade as your business grows. We offer smooth transitions without data loss.",
    },
    {
      question: "Do you offer custom website designs?",
      answer:
        "Yes! Our Business and Premium plans include custom UI/UX design tailored specifically to your brand and business needs.",
    },
    {
      question: "Is SEO included in the website package?",
      answer:
        "Basic SEO setup is included in all packages. Our Premium plan offers advanced SEO optimization including schema, meta tags, and page speed improvements.",
    },
    {
      question:
        "Can I request specific features like booking, payments, or blogs?",
      answer:
        "Yes, we provide custom feature integrations such as appointment booking, payment gateways, and blogging systems depending on your business type.",
    },
    {
      question: "Do you provide post-launch support or maintenance?",
      answer:
        "Yes. The Premium plan includes 3 months of free maintenance. Additional support and AMC (Annual Maintenance Contract) can also be purchased.",
    },
  ],
};
export const CRMERPPageDetails = {
  SeoName: {
    seotitle: "crmerppanelsseo",
  },
  section2: {
    tagline: "Looking to streamline your operations?",
    heading: "Build Custom CRM & ERP Solutions Tailored to Your Business.",
    description:
      "At Cyber Space Digital, we develop intelligent, scalable, and secure CRM & ERP systems to automate your business processes, improve productivity, and drive growth across all departments.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "CRM for Small Businesses",
      description: "Manage customers, leads, and communication with ease.",
      details: [
        "Lead Management: Track potential customers and sales funnels.",
        "Customer Data: Centralized contact info, activity history, and notes.",
        "Follow-ups & Reminders: Never miss an opportunity with automation tools.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Sales & Marketing CRM",
      description: "Automate campaigns and increase lead conversion.",
      details: [
        "Email/SMS Campaigns: Create and schedule drip marketing.",
        "Sales Pipeline: Visualize stages and monitor conversions.",
        "Reports & Analytics: Track sales trends and agent performance.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "ERP for Inventory & Accounting",
      description: "End-to-end business management platform.",
      details: [
        "Inventory Tracking: Stock levels, purchase orders, suppliers.",
        "Billing & Invoicing: GST-ready invoicing and payment tracking.",
        "Accounting Module: Expense, profit/loss, and ledger management.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "HRM & Payroll Systems",
      description: "Manage employee data, attendance, and payroll.",
      details: [
        "Employee Profiles: Role-based access and management.",
        "Attendance & Leaves: Biometric/API-based tracking.",
        "Payroll: Salary calculation, payslips, tax deductions.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Custom ERP Modules",
      description: "Industry-specific ERP modules built to scale.",
      details: [
        "Salon/Clinic ERP: Appointments, inventory, staff roles.",
        "Logistics ERP: Dispatch, vehicle tracking, customer support.",
        "Restaurant ERP: Orders, KOT, kitchen, and billing integration.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Multi-Tenant ERP",
      description: "Host multiple companies in one secure environment.",
      details: [
        "Separate dashboards, role-based login.",
        "Isolated data per tenant, central super-admin control.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Mobile CRM/ERP Access",
      description: "Access your ERP or CRM from anywhere.",
      details: [
        "Android/iOS Apps: Real-time access on the go.",
        "Push Notifications: Stay updated with task alerts and follow-ups.",
        "Offline Mode: Work even without active internet.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter CRM",
      price: "",
      features: [
        "Lead & Contact Management",
        "Task Reminders",
        "Single Admin Access",
        "Delivery in 7 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business ERP",
      price: "",
      features: [
        "CRM + Inventory + Invoicing",
        "Role-based Login",
        "Reports & Dashboard",
        "Free Maintenance for 1 Month",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium ERP Suite",
      price: "",
      features: [
        "All-in-one ERP System",
        "HR, Payroll, Finance, CRM, Inventory",
        "Mobile App Integration",
        "AMC & Priority Support",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: WebdevelopmentMain_Development_CoverImage,
  title: "Looking for a Custom CRM or ERP Solution?",
  subtitle:
    "Cyber Space Digital helps businesses automate operations with intelligent, secure, and scalable ERP and CRM systems tailored to your exact workflow.",
  coverImage: {
    src: WebdevelopmentMain_Development_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is the difference between CRM and ERP?",
      answer:
        "CRM (Customer Relationship Management) focuses on sales, customer communication, and lead tracking. ERP (Enterprise Resource Planning) manages broader business functions like inventory, HR, billing, and accounting.",
    },
    {
      question: "Can you build a custom CRM for my business type?",
      answer:
        "Yes, we specialize in custom CRM/ERP systems for various industries like salons, clinics, logistics, and service agencies. Features are tailored to your workflow.",
    },
    {
      question: "Is training provided for the CRM/ERP system?",
      answer:
        "Absolutely! We provide video training, live demos, and documentation so your team can adapt easily.",
    },
    {
      question: "Do you offer mobile versions?",
      answer:
        "Yes, our Premium ERP suite includes mobile app access for Android and iOS, including offline capabilities and push notifications.",
    },
    {
      question: "Is multi-user access available?",
      answer:
        "Yes. Our systems support admin, manager, staff, and custom user roles with permission-based access.",
    },
    {
      question: "Can I integrate billing and inventory in the CRM?",
      answer:
        "Yes. Our Business and Premium plans support integrated inventory, invoicing, and even GST-ready billing modules.",
    },
    {
      question: "Do you offer AMC and ongoing support?",
      answer:
        "Yes. All plans include free maintenance (duration varies). AMC and priority support options are also available.",
    },
  ],
};
export const EcommercePageDetails = {
  SeoName: {
    seotitle: "ecommercewebsiteseo",
  },
  section2: {
    tagline: "Want to grow your sales with a powerful online store?",
    heading: "Build, Scale & Grow Your Online Storefront.",
    description:
      "At Cyber Space Digital, we specialize in creating scalable, high-performance e-commerce platforms that convert visitors into loyal customers. From inventory to checkout, we craft seamless shopping experiences.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Single Product Store",
      description: "Perfect for launching one key product.",
      details: [
        "Ideal for focused campaigns or startups. Includes product landing page, payment integration, customer reviews, and analytics setup.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Multi-Product E-Commerce",
      description: "Standard e-commerce store setup.",
      details: [
        "Includes product catalog, filters, cart, checkout, payment gateway, shipping modules, order management, and customer dashboard.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Marketplace Platform",
      description: "Multi-vendor platform for large-scale selling.",
      details: [
        "Vendor onboarding, individual dashboards, commission models, payout systems, product moderation, and reviews.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Subscription Commerce",
      description: "Perfect for recurring sales businesses.",
      details: [
        "Subscription billing, user account management, auto-renewals, pause/cancel options, and payment retries.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Wholesale / B2B Portals",
      description: "E-commerce for bulk buyers and distributors.",
      details: [
        "Custom pricing tiers, volume discounts, bulk order uploads, quote requests, and GST/tax invoice integrations.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Custom Commerce Solutions",
      description: "Tailored platforms with unique features.",
      details: [
        "Integrate ERP, CRM, third-party APIs, logistics, affiliate systems, and more based on your business model.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter E-commerce",
      price: "",
      features: [
        "Single Product Setup",
        "Payment Gateway Integration",
        "Basic Responsive UI",
        "Delivery in 5 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Business Store",
      price: "",
      features: [
        "Up to 30 Products",
        "Full Shopping Cart & Checkout",
        "Custom Design + Domain + Hosting",
        "Email IDs + Order Management",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Store",
      price: "",
      features: [
        "Unlimited Products",
        "Advanced Filters + PWA Support",
        "Multi-Payment + Shipping Integration",
        "Free Maintenance for 3 Months",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: WebdevelopmentMain_Development_CoverImage,
  title: "Looking to launch your E-commerce business?",
  subtitle:
    "Cyber Space Digital builds modern online stores equipped with the tools you need to succeed in the digital marketplace.",
  coverImage: {
    src: WebdevelopmentMain_Development_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Can I sell digital and physical products both?",
      answer:
        "Yes, our platform supports both physical and digital goods with separate fulfillment workflows and download management.",
    },
    {
      question: "Will my site support UPI, Credit Cards, and COD?",
      answer:
        "Yes. We integrate secure payment gateways like Razorpay, Stripe, or Cashfree to support UPI, cards, wallets, and COD.",
    },
    {
      question: "Is the e-commerce website mobile responsive?",
      answer:
        "Absolutely. All e-commerce sites are fully responsive and tested across modern mobile and tablet devices.",
    },
    {
      question: "Can I manage my orders and inventory?",
      answer:
        "Yes. You'll receive an admin panel to manage orders, inventory, discounts, and customer details easily.",
    },
    {
      question: "Do you offer integrations with courier services?",
      answer:
        "We offer integrations with major logistics providers like Shiprocket, Delhivery, and others for automated tracking and order syncing.",
    },
    {
      question: "Will my store be SEO friendly?",
      answer:
        "Yes. We ensure SEO-friendly structure, schema markup, meta tags, and clean URLs for optimal visibility.",
    },
    {
      question: "Can I upgrade my store later with more features?",
      answer:
        "Definitely. Our solutions are scalable. You can start small and upgrade to a full-fledged marketplace anytime.",
    },
    {
      question: "Do I get analytics and reports?",
      answer:
        "Yes. We integrate Google Analytics, Facebook Pixel, and dashboard reports to track user behavior, sales, and conversions.",
    },
  ],
};
export const WebRevapPageDetails = {
  SeoName: {
    seotitle: "webrevapseo",
  },
  section2: {
    tagline: "Is your website outdated or underperforming?",
    heading: "Revamp Your Website for a Stronger Digital Presence",
    description:
      "Cyber Space Digital helps businesses modernize their websites with responsive designs, speed optimizations, UI/UX improvements, and added features to match current trends and user expectations.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "UI/UX Redesign",
      description: "Improve user experience and engagement",
      details: [
        "Complete UI overhaul with modern design principles.",
        "Mobile responsiveness, accessibility, and intuitive navigation.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Performance Optimization",
      description: "Speed up your website for better conversions",
      details: [
        "Image and asset optimization, code cleanup, and caching.",
        "Improve Core Web Vitals, reduce load time, and enhance user satisfaction.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Content & SEO Overhaul",
      description: "Improve visibility and messaging",
      details: [
        "Revise outdated content and meta-data.",
        "Add keyword-focused structure for higher rankings.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Feature Additions",
      description: "Add new capabilities and functionality",
      details: [
        "Blog setup, contact forms, booking system, gallery, testimonials, etc.",
        "E-commerce integration, CRM connection, or live chat plugins.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Technology Upgrade",
      description: "Migrate to a modern tech stack",
      details: [
        "Move from outdated platforms to modern CMS or frameworks.",
        "Ensure security, scalability, and maintainability.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Full Website Rebuild",
      description: "Start fresh with a clean slate",
      details: [
        "Analyze your goals, rebuild layout, and structure from scratch.",
        "Best for websites with broken architecture or very old technology.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Revamp",
      price: "",
      features: [
        "UI Color & Typography Update",
        "Basic Layout Cleanup",
        "Speed Optimization",
        "3-Day Delivery",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Professional Revamp",
      price: "",
      features: [
        "Complete UI/UX Redesign",
        "Page Speed Optimization",
        "Mobile Responsive",
        "SEO Re-structure",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Advanced Rebuild",
      price: "",
      features: [
        "New Design + New CMS (WordPress/React)",
        "All Features Reintegrated",
        "Advanced SEO + Analytics",
        "3 Months Support",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: WebdevelopmentMain_Development_CoverImage,
  title: "Want to Redesign Your Website?",
  subtitle:
    "Cyber Space Digital is your go-to partner for transforming outdated or ineffective websites into modern, high-performing digital platforms.",
  coverImage: {
    src: WebdevelopmentMain_Development_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why should I revamp my website?",
      answer:
        "A revamp helps improve user experience, SEO performance, brand trust, and conversion rates by modernizing design, speed, and features.",
    },
    {
      question: "Can I keep my existing content?",
      answer:
        "Yes, we can preserve your content while improving the design and functionality. Well also suggest content improvements for better SEO.",
    },
    {
      question: "How long does a website revamp take?",
      answer:
        "Depending on the scope, it can take 3 to 15 days. Basic revamps are quicker, while complete rebuilds take longer.",
    },
    {
      question: "Will my site experience downtime?",
      answer:
        "No. We work on a staging copy and switch over once the new site is ready, ensuring zero downtime.",
    },
    {
      question: "Can I add new features during the revamp?",
      answer:
        "Absolutely. We encourage including new functionality like chat, booking, blogs, or e-commerce during the redesign.",
    },
    {
      question: "Do you support post-launch updates?",
      answer:
        "Yes. Our Advanced plan includes 3 months of support. We also offer annual maintenance contracts.",
    },
  ],
};

//DefaultIcon
